// const SponsorsData = [
//   {
//     title: "Gold",
//     key: "01",
//     benefits: [
//       "Two 8 x 10 booths in prime location at the Annual Conference",
//       "Four complimentary registrations to the Annual Conference from your company",
//       "Two complimentary registrations to the Annual Conference from pharma/biotech manufacturers for your clients",
//       "Invited to the special event to meet with industry leaders",
//       "Have 10 min on podium to address SOS audience, or present with client at conference",
//       "Participate on stage for one of the panels",
//       "30 second advertisement to be played at the beginning of a General Session; based on availability",
//       "Link and company logo on SOS website home page and the conference page for one year",
//       "Sidebar ad on SOS website",
//       "Enhanced verbal recognition as sponsor of the Annual Conference",
//       "Enhanced sign recognition at Annual Conference",
//       "Slide loop to be played before start of a General Session; based on availability",
//       "Chair drop during a General Session at the conference; based on availability",
//       "SOS will distribute white paper to all members (up to 3 white papers)",
//     ],
//   },
//   {
//     title: "Silver",
//     key: "02",
//     benefits: [
//       "One 8 x 10 booth at the Annual Conference",
//       "Three complimentary registrations to the Annual Conference",
//       "One complimentary registration from pharma manufacturer to the Annual Conference to offer to your clients",
//       "Seat on the panel discussion; based on availability",
//       "20 second advertisement to be played at the beginning of a General Session; based on availability",
//       "Link and company logo on SOS website home page and the conference page for one year",
//       "Sidebar ad on SOS website",
//       "Enhanced verbal recognition as sponsor of the Annual Conference",
//       "Enhanced sign recognition at Annual Conference",
//       "Slide loop to be played before start of a General Session; based on availability",
//       "Chair drop during a General Session at the conference; based on availability",
//       "SOS will distribute white paper to all members (up to 2 white papers)",
//     ],
//   },
//   {
//     title: "Exhibitor",
//     key: "03",
//     benefits: [
//       "One 8 x 10 booth at the Annual Conference",
//       "Two complimentary registrations to the Annual Conference",
//       "Link and company logo on SOS website home page and the conference page for one year",
//       "Verbal recognition as sponsor of the Annual Conference",
//       "Sign recognition at Annual Conference",
//     ],
//   },
// ];

const SponsorsData = [
  {
    title: "Gold",
    key: "01",
    price: "$15,000",
    benefits: [
      "One 8 x 10 booth in prime location at the Annual Conference",
      "Ten complimentary registrations from your company to the Annual Conference",
      "Ten complimentary registrations from pharma manufacturer to the Annual Conference to offer to your clients",
      "Invited to the special event to meet with industry leaders",
      "Have 10 min on podium to address SOS audience, or present at conference, ideally on a case study with a client",
      "30 second advertisement to be played at the beginning of a General Session; based on availability",
      "Link and company logo on SOS website home page and the conference page for one year",
      "Sidebar ad on SOS website",
      "Enhanced verbal recognition as sponsor of the Annual Conference",
      "Enhanced sign recognition at Annual Conference",
      "Slide loop to be played before start of a General Session; based on availability",
      "Chair drop during a General Session at the conference; based on availability",
      "SOS will distribute white paper to all members (up to 3 white papers)",
    ],
  },
  {
    title: "Silver",
    key: "02",
    price: "$9,000",
    benefits: [
      "One 8 x 10 booth at the Annual Conference",
      "Seven complimentary registrations to the Annual Conference",
      "Seven complimentary registrations from pharma manufacturer to the Annual Conference to offer to your clients",
      "Seat on the panel discussion; based on availability",
      "20 second advertisement to be played at the beginning of a General Session; based on availability",
      "Link and company logo on SOS website home page and the conference page for one year",
      "Sidebar ad on SOS website",
      "Enhanced verbal recognition as sponsor of the Annual Conference",
      "Enhanced sign recognition at Annual Conference",
      "Slide loop to be played before start of a General Session; based on availability",
      "Chair drop during a General Session at the conference; based on availability",
      "SOS will distribute white paper to all members (up to 2 white papers)",
    ],
  },
  {
    title: "Bronze",
    key: "03",
    price: "$6,000",
    benefits: [
      "One 8 x 10 booth at the Annual Conference",
      "Five complimentary registrations to the Annual Conference",
      "Five complimentary registrations from pharma manufacturer to the Annual Conference to offer to your clients",
      "Link and company logo on SOS website home page and the conference page for one year",
      "Sidebar ad on SOS website",
      "Enhanced verbal recognition as sponsor of the Annual Conference",
      "Enhanced sign recognition at Annual Conference",
      "SOS will distribute white paper to all members (up to 2 white papers)",
    ],
  },
  {
    title: "Special Event",
    key: "04",
    price: "$5,000",
    benefits: [
      "Five complimentary registrations to the Annual Conference",
      "Five complimentary registrations from pharma manufacturer to the Annual Conference to offer to your clients",
      "Link and company logo on SOS website home page and the conference page for one year",
      "Sidebar ad on SOS website",
      "Enhanced verbal recognition as sponsor of the Annual Conference",
      "Enhanced sign recognition at Annual Conference",
      "SOS will distribute white paper to all members (up to 2 white papers)",
    ],
  },
  {
    title: "Leadership Cocktail & Dinner",
    key: "05",
    price: "$3,000",
    benefits: [
      "Three complimentary registrations to the Annual Conference",
      "Three complimentary registrations from pharma manufacturer to the Annual Conference to offer to your clients",
      "Sidebar ad on SOS website",
      "Enhanced verbal recognition as sponsor of the Annual Conference",
      "Enhanced sign recognition at Annual Conference",
      "SOS will distribute white paper to all members (up to 2 white papers)",
      "Company logo placed on service table",
    ],
  },
  {
    title: "Lunch Break Sponsor",
    key: "06",
    price: "$2,000",
    benefits: [
      "Two complimentary registrations to the Annual Conference",
      "Two complimentary registrations from pharma manufacturer to the Annual Conference to offer to your clients",
      "Enhanced verbal recognition as sponsor of the Annual Conference",
      "Enhanced sign recognition at Annual Conference",
      "SOS will distribute white paper to all members (up to 2 white papers)",
      "Company logo placed on service table",
    ],
  },
  {
    title: "High Tea Break Sponsor",
    key: "07",
    price: "$1,200",
    benefits: [
      "Two complimentary registrations to the Annual Conference",
      "Two complimentary registrations from pharma manufacturer to the Annual Conference to offer to your clients",
      "Company logo placed on service table",
    ],
  },
  {
    title: "WiFi Password Sponsor",
    key: "08",
    price: "$1,000",
    benefits: [
      "Two complimentary registrations to the Annual Conference",
      "Two complimentary registrations from pharma manufacturer to the Annual Conference to offer to your clients",
    ],
  },
];

export default SponsorsData;
